import { useState } from "react";
import { Animate, Icon } from "components/lib";

type Props = {
  title: string;
  children?: React.ReactNode;
};

export function DropCard({ title, children }: Props) {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="border-b border-slate-200 flex flex-col justify-between p-4 rounded-[5px] transition-all duration-150 ease-in-out h-auto">
      <button
        type="button"
        className="cursor-pointer flex justify-between items-center w-full text-black font-bold text-lg"
        onClick={() => setShowAll(!showAll)}
        aria-expanded={showAll}
        aria-controls={`dropCardContent-${title}`}
      >
        {title}
        {showAll ? (
          <Icon image="chevron-up" size={20} />
        ) : (
          <Icon image="chevron-down" size={20} />
        )}
      </button>
      {showAll && (
        <div id={`dropCardContent-${title}`}>
          <Animate type="slidedown">
            <div className="py-2 w-full">{children}</div>
          </Animate>
        </div>
      )}
    </div>
  );
}
